<template>
<div>
    <header>
        <div class="inr">
            <span class="prev">
                <a @click="$router.go(-1)">
                    <img src="@/assets/image/icon-prev.png" alt="뒤로가기">
                </a>
            </span>
            <h1>이벤트</h1>
        </div>
    </header>
    <Footer />
    <main id="sub" class="notice">
        <div class="inr" v-if="eventList.length > 0">
            <div class="notice-list-wrap">
                <ul class="notice-lists">
                    <li class="notice-list" v-for="(event, idx) in eventList" :key="idx" @click="goToLink(event.pk)">
                        <dl>
                            <dt>
                                <span class="new" v-if="event.is_top">
                                    <i class="fa-solid fa-volume-high"></i>
                                    <template v-if="event.is_new">&nbsp;[NEW]</template>
                                </span>
                                <span class="new" v-else-if="event.is_new">
                                    <template>[NEW]</template>
                                </span>
                                <span :class="{'font-bold' : event.is_top}">
                                    {{event.title}}
                                </span>
                            </dt>
                            <dd>{{event.created}}</dd>
                        </dl>
                    </li>
                </ul>
            </div>
        </div>
        <div class="no-result" v-else>
            <div class="no-result-txt" v-html="blankMsg">
            </div>
        </div>
    </main>
</div>
</template>

<script>
import Footer from "@/components/common/Footer";

export default {
    components: {
        Footer
    },
    data() {
        return {
            blankMsg: "",
            eventList: [],

            subtract_day: moment().subtract(7, "days").format("YYYY-MM-DD"),
            today: moment().format("YYYY-MM-DD")
        };
    },
    mounted() {
        this.axios.get(`/board/event`).then(res => {
            res.data.result.forEach(item => {
                item.attachments = JSON.parse(item.attachments);
                item.created = moment(item.created).format("YYYY-MM-DD");
                item.is_new = moment(item.created).isBetween(this.subtract_day, this.today, undefined, '[]');
            });
            this.eventList = res.data.result;

            if (this.eventList.length <= 0) {
                this.blankMsg = "등록된 이벤트가 <br>존재하지 않습니다.";
            }
        }).catch(err => {
            console.log(err);
        });
    },
    methods: {
        goToLink(pk) {
            this.$router.push({
                path: `/event/detail/${pk}`
            });
        }
    }
};
</script>
